<!--
 * @Description: 加载服务，协议 等 docs
 * @Version: 0.0.1
 * @Author: yujiangping
 * @Date: 2024-06-20 13:53:37
 * @LastEditors: yujiangping
 * @LastEditTime: 2025-01-03 11:05:25
-->
<template>
    <div class="flex-col bg-white mt-58">
        <!-- <header-nav /> -->
        <div class="container1 ptb-20 plr-20">
            <div v-html="htmlContent"></div>
        </div>
        <!-- <div class="container h-full-1800">
            <iframe :src="docs" width="100%" height="100%" frameborder="0"></iframe>
        </div> -->

        <!-- <airb-footer class="mt-60"/> -->
    </div>
</template>
<script>
import headerNav from '@/components/nav.vue'
import airbFooter from '@/components/footer.vue'
export default {
    components:{
        headerNav, airbFooter
    },
    data(){
        return{
            docs:'',
            htmlContent:'',
            serviceDocs:'https://img.redbearai.com/ServiceAgreement.html',
            privacyDOcs:'https://img.redbearai.com/PrivacyAgreement.html'
        }
    },
    mounted(){
        if(this.$route.query.name === 'service'){
            this.docs = this.serviceDocs
        }else{
            this.docs = this.privacyDOcs
        }
        this.loadHtmlFile()
    },
    methods:{
        loadHtmlFile(){
            this.htmlContent = ""
            let xhr = new XMLHttpRequest()
            xhr.open('GET',this.docs,false)
            xhr.overrideMimeType("text/html;charset=utf-8")
            xhr.send(null)
            this.htmlContent = xhr.responseText
        }
    }
}
</script>
<style>
.mt-58{
    margin-top: -58px;
    background: #Fff;
}
</style>